import React from 'react';
import { Layout } from 'fronton-react';
import { OtherSection, RootLayout } from 'common/components';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import { StepsSection, STEPS_LIST } from '../components';
import { AdvantagesSection, FeaturesSection, HeaderSection, SystemsSection } from './components';
import { DEFAULT_CONSULTATION_SUB_CHANNEL } from '../engineering-systems-constants';
import {
  ENGINEERING_SYSTEMS_CONSULTATION_TYPE,
  ENGINEERING_SYSTEMS_LANDING_NAME,
  MAIN_PAGE_CONSULTATION_SECTION_TITLE,
  MAIN_PAGE_PATH,
} from './main-page-constants';

type MainPageProps = {
  consultationSectionRef: (el: HTMLElement | null) => void;
  onConsultationSignupBtnClick: () => void;
};

/**
 * Вью страницы "Инженерные системы"
 */
export const MainPage = ({ consultationSectionRef, onConsultationSignupBtnClick }: MainPageProps) => (
  <RootLayout currentPage={MAIN_PAGE_PATH}>
    <Layout>
      <HeaderSection onConsultationSignupBtnClick={onConsultationSignupBtnClick} />
      <FeaturesSection />
      <PromoBlock elementBlock="landingSistemyInzhenernye" />
      <SpecialOffer
        onModalBtnClick={onConsultationSignupBtnClick}
        elementBlock="landingSistemyInzhenernye"
      />
      <SystemsSection />
      <AdvantagesSection />
      <StepsSection stepNameVariant="h2" stepSectionList={STEPS_LIST} />
      <ConsultationSection
        consultationType={ENGINEERING_SYSTEMS_CONSULTATION_TYPE}
        elementBlock="landingSistemyInzhenernye"
        elementText="Заявка на консультацию"
        sectionRef={consultationSectionRef}
        sectionTitle={MAIN_PAGE_CONSULTATION_SECTION_TITLE}
        subChannel={DEFAULT_CONSULTATION_SUB_CHANNEL}
      />
    </Layout>
    <OtherSection
      elementBlock="landingSistemyInzhenernye / other"
      landingName={ENGINEERING_SYSTEMS_LANDING_NAME}
      promotionName="SistemyInzhenernye_bottom"
    />
  </RootLayout>
);
